import React, {useState, useEffect, Fragment} from "react";
import { isAuthenticated } from "./helper";
import { Link } from "react-router-dom";
import {useParams} from "react-router-dom"
const SinglePost = () => {
    const [comment, setComment] = useState("")
    const [post, setPost] =useState([]);
    const {postId} = useParams()
    const {user, token} = isAuthenticated()
    const [loading, setLoading] = useState(true)
    useEffect(() => {
        fetch(`${process.env.REACT_APP_BACKEND}/singlepost/${postId}`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        .then(res=> res.json())
        .then(data => {
            console.log(data);
            setLoading(false)
            setPost(data)
            console.log("here")
        })
        .catch(err => console.log(err))
    }, [])


    return (
        <Fragment>
        <div className="row">
            <div className="col offset-s3 s6 center-align">
                <div className="card-panel red white-text">
                    Please <Link to="/login">Login Here</Link> to like and comment on this post.
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col s12">
                <div className="home">
                {
                    post.map(item => {
                        return( 
                            
                            
                            <div className="card home-card"  key={item._id}>
                                <h5 style={{textAlign:"left", marginLeft: "3%"}}>
                                
                                <img className="circle" height="40" width="40" style={{marginTop: "5px", marginRight: "5px"}} src={item.postedBy.pic}/>
                                <Link to="/login">
                                {item.postedBy.name}
                                </Link>
                                
                                
                                </h5>
                                <div className="card-image">
                                    <img src={item.photo}/>
                                </div>
                                <div className="card-content">
                                    <i className="material-icons" style={{color: "red"}}>favorite</i>
                                    
                                        <i className="material-icons">thumb_up</i>
                                    
                                    
                                    
                                    <h6>{item.likes.length} likes</h6>
                                    <h6>{item.title}</h6>
                                    <p>{item.body}</p>
                                    {
                                        item.comments.map(record => {
                                            return (
                                                <h6 key={record._id}><span style={{fontWeight: "700"}}>{record.postedBy.name}</span> {record.text} 
                                                
                                                
                                                
                                                </h6>
                                            )
                                        })
                                    }   
                                    
                                    
                                </div>
                            </div>
                            
                        )
                    })
                }
                    
                </div>
            </div>
            {loading && 
                <div className="preloader-background">
            <div class="preloader-wrapper big active">
                <div class="spinner-layer spinner-blue-only">
                <div class="circle-clipper left">
                    <div class="circle"></div>
                </div><div class="gap-patch">
                    <div class="circle"></div>
                </div><div class="circle-clipper right">
                    <div class="circle"></div>  
                </div>
                </div>
            </div>
            </div>
            }
        </div>
        </Fragment>
    )
}

export default SinglePost;